import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const Wrapper = styled.div`
  direction: ${(props) => (props.$isArabic ? 'rtl' : 'ltr')};

  /* Fixed container for button + label */
  .whatsapp-container {
    position: fixed;
    bottom: 1.5rem;
    ${(props) => (props.$isArabic ? 'left: 0.8rem' : 'right: 0.8rem')};
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  /* Main floating button */
  .whatsapp-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #25d366;
    color: #fff;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
    animation: ${pulse} 2s infinite;
    order: 2;
    flex-shrink: 0;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5);
    }
  }

  .whatsapp-icon {
    font-size: 2rem;
  }

  /* Label bubble above the button */
  .label-bubble {
    order: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: #333;
    padding: 8px 16px;
    border-radius: 24px;
    border: 1.5px solid rgba(37, 211, 102, 0.5);
    font-size: 0.9rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.25s ease;
    animation: ${fadeIn} 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(37, 211, 102, 0.25);
    }

    .label-close {
      background: none;
      border: none;
      color: #999;
      font-size: 1.2rem;
      cursor: pointer;
      padding: 0 0 0 4px;
      line-height: 1;

      &:hover {
        color: #333;
      }
    }
  }

  /* Chat popup */
  .chat-popup {
    position: fixed;
    bottom: 6rem;
    ${(props) => (props.$isArabic ? 'left: 1.5rem' : 'right: 1.5rem')};
    z-index: 9998;
    width: 320px;
    background: #fff;
    border-radius: 16px;
    border: 2px solid #25d366;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    animation: ${fadeIn} 0.3s ease;
  }

  .chat-header {
    display: flex;
    justify-content: ${(props) => (props.$isArabic ? 'flex-start' : 'flex-end')};
    padding: 12px 16px 0;
  }

  .chat-icon {
    font-size: 1.8rem;
    color: #25d366;
    background: #e8faf0;
    border-radius: 50%;
    padding: 8px;
    width: 42px;
    height: 42px;
  }

  .chat-body {
    padding: 12px 20px 20px;
    text-align: center;
  }

  .chat-heading {
    font-size: 1rem;
    font-weight: 600;
    color: #222;
    margin-bottom: 6px;
    line-height: 1.5;
  }

  .chat-welcome {
    font-size: 0.85rem;
    color: #888;
    margin-bottom: 16px;
  }

  .chat-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 12px;
    background: #222;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #333;
    }

    .cta-icon {
      font-size: 1.3rem;
      color: #25d366;
    }

    .cta-arrow {
      margin-${(props) => (props.$isArabic ? 'right' : 'left')}: 4px;
      font-size: 1.1rem;
    }
  }

  @media (max-width: 576px) {
    .whatsapp-container {
      bottom: 1rem;
      ${(props) => (props.$isArabic ? 'left: 0.6rem' : 'right: 0.6rem')};
      gap: 8px;
    }

    .whatsapp-btn {
      width: 52px;
      height: 52px;
    }

    .whatsapp-icon {
      font-size: 1.7rem;
    }

    .label-bubble {
      font-size: 0.8rem;
      padding: 6px 12px;
    }

    .chat-popup {
      width: calc(100vw - 2rem);
      bottom: 5rem;
      ${(props) => (props.$isArabic ? 'left: 1rem' : 'right: 1rem')};
    }
  }
`;

export default Wrapper;
